import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Login from '@/views/Login.vue'
import NotFound from '@/views/404.vue'
import Home from '@/views/Home.vue'
import Main from '@/views/Main.vue'

// let routes = [
    // {
    //     path: '/login',
    //     component: Login,
    //     name: '',
    //     hidden: true
    // },
    // {
    //     path: '/forgotPwd',
    //     component: resolve => require(['@/views/ForgotPwd.vue'], resolve),
    //     name: '',
    //     hidden: true
    // },
    // {
    //     path: '/404',
    //     component: NotFound,
    //     name: '',
    //     hidden: true
    // },
    // {
    //     path: '/device/detail',
    //     component: resolve => require(['@/views/device/detail.vue'], resolve),
    //     name: '',
    //     hidden: true
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '监控中心',
    //     iconCls: 'fa fa-tv',
    //     children: [
    //         { path: '/monitor/map', component: resolve => require(['@/views/monitor/map.vue'], resolve), name: '地图展示' },
    //         { path: '/analysis/mainAnalyze', component: resolve => require(['@/views/analysis/mainAnalyze.vue'], resolve), name: '分析报表' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '设备管理',
    //     iconCls: 'fa fa-laptop',
    //     children: [
    //         { path: '/device/list', component: resolve => require(['@/views/device/list.vue'], resolve), name: '设备列表' },
    //         { path: '/device/extinfo', component: resolve => require(['@/views/device/extinfo.vue'], resolve), name: '设备拓展信息' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '数据管理',
    //     iconCls: 'fa fa-database',
    //     children: [
    //         { path: '/history', component: resolve => require(['@/views/data/history.vue'], resolve), name: '历史数据' },
    //     ]
    // },
    // {
    //     path: '/analysis/energy',
    //     component: Home,
    //     name: '能耗分析',
    //     leaf: true,
    //     iconCls: 'fa fa-line-chart',
    //     children: [
    //         { path: '/analysis/energy', component: resolve => require(['@/views/analysis/energy.vue'], resolve), name: '能耗分析' }
    //     ],
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '触发器管理',
    //     iconCls: 'fa fa-bell',
    //     children: [
    //         { path: '/trigger/list', component: resolve => require(['@/views/trigger/list.vue'], resolve), name: '触发器列表' },
    //         { path: '/trigger/add', component: resolve => require(['@/views/trigger/add.vue'], resolve), name: '添加触发器' },
    //         { path: '/trigger/edit', component: resolve => require(['@/views/trigger/add.vue'], resolve), name: '编辑触发器', hidden: true },
    //         { path: '/trigger/contact', component: resolve => require(['@/views/trigger/contact/list.vue'], resolve), name: '报警联系人/组' },
    //         { path: '/trigger/alarmHistory', component: resolve => require(['@/views/trigger/alarmHistory.vue'], resolve), name: '报警记录' }
    //     ]
    // },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '用户中心',
    //     iconCls: 'fa fa-id-card-o',
    //     children: [
    //         { path: '/user/role', component: resolve => require(['@/views/user/role.vue'], resolve), name: '角色管理' },
    //         { path: '/user/user', component: resolve => require(['@/views/user/user.vue'], resolve), name: '子用户管理' },
    //         { path: '/user/info', component: resolve => require(['@/views/user/userinfo.vue'], resolve), name: '用户信息' },
    //         { path: '/user/password', component: resolve => require(['@/views/user/password.vue'], resolve), name: '用户密码' },
    //         { path: '/user/wxbind', component: resolve => require(['@/views/user/wxbind.vue'], resolve), name: '微信绑定管理' }
    //     ]
    // },





    // {
    //     path: '/analysis/energy',
    //     // component: Home,
    //     name: '能耗分析',
    //     leaf: true,
    //     iconCls: 'fa fa-laptop',
    //     // children: [
    //     //     { path: '/analysis/energy', component: resolve => require(['@/views/analysis/energy.vue'], resolve), name: '能耗分析',hidden: true }
    //     // ]
    // },

//     {
//         path: '*',
//         hidden: true,
//         redirect: { path: '/404' }
//     }
// ];

export const constantRoutes = [
    {
        path: '/login',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/forgotPwd',
        component: resolve => require(['@/views/ForgotPwd.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/forgotPwdL2',
        component: resolve => require(['@/views/ForgotPwdL2.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    }
]

export const asyncRoutes = [
    {
        path: '/device/detail',
        component: resolve => require(['@/views/device/detail.vue'], resolve),
        name: '',
        hidden: true
    },
    {
        path: '/',
        component: Home,
        name: '监控中心',
        iconCls: 'fa fa-tv',
        children: [
            // { path: '/monitor/map', component: resolve => require(['@/views/monitor/map.vue'], resolve), name: '地图展示' },
            // { path: '/analysis/mainAnalyze', component: resolve => require(['@/views/analysis/mainAnalyze.vue'], resolve), name: '分析报表' }
            { path: '/monitor/map', component: resolve => require(['@/views/monitor/mapL2.vue'], resolve), name: '地图展示' },
            // { path: '/analysis/mainAnalyze', component: resolve => require(['@/views/analysis/mainAnalyzeL2.vue'], resolve), name: '分析报表' }
            { path: '/device/list', component: resolve => require(['@/views/device/list.vue'], resolve), name: '设备列表',meta: {roles:['admin']} },
            { path: '/device/listL2', component: resolve => require(['@/views/device/listL2.vue'], resolve), name: '设备列表',meta: {roles:['region_1', 'third_role_1']} }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '设备管理',
        iconCls: 'fa fa-laptop',
        children: [
            { path: '/device/extinfo', component: resolve => require(['@/views/device/extinfo.vue'], resolve), name: '设备拓展信息',meta: {roles:['admin']} },
        ],
        meta: {roles:['admin','region_1', 'third_role_1']}
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '设备管理',
    //     iconCls: 'fa fa-laptop',
    //     children: [
    //         { path: '/device/listL2', component: resolve => require(['@/views/device/listL2.vue'], resolve), name: '设备列表' },
    //         { path: '/device/extinfo', component: resolve => require(['@/views/device/extinfo.vue'], resolve), name: '设备拓展信息' }
    //     ],
    //     meta: {roles:['region_1']}
    // },
    {
        path: '/',
        component: Home,
        name: '数据管理',
        iconCls: 'fa fa-database',
        children: [
            // { path: '/history', component: resolve => require(['@/views/data/history.vue'], resolve), name: '历史数据' },
            { path: '/history', component: resolve => require(['@/views/data/historyL2.vue'], resolve), name: '历史数据' }
        ]
    },
    {
        path: '/',
        component: Home,
        name: '能耗管理',
        leaf: true,
        iconCls: 'fa fa-line-chart',
        children: [
            // { path: '/analysis/energy', component: resolve => require(['@/views/analysis/energy.vue'], resolve), name: '能耗分析' }
            { path: '/analysis/energy', component: resolve => require(['@/views/analysis/energyL2.vue'], resolve), name: '能耗分析' }
        ],
    },
    {
        path: '/',
        component: Home,
        name: '预警管理',
        iconCls: 'fa fa-bell',
        children: [
            { path: '/trigger/list', component: resolve => require(['@/views/trigger/list.vue'], resolve), name: '预警项列表', meta: {roles:['admin']} },
            { path: '/trigger/listL2', component: resolve => require(['@/views/trigger/listL2.vue'], resolve), name: '预警项列表', meta: {roles:['region_1', 'third_role_1']} },
            { path: '/trigger/add', component: resolve => require(['@/views/trigger/add.vue'], resolve), name: '添加预警设置' , meta: {roles:['admin']}},
            { path: '/trigger/addL2', component: resolve => require(['@/views/trigger/addL2.vue'], resolve), name: '添加预警设置' , meta: {roles:['region_1', 'third_role_1']}},
            { path: '/trigger/edit', component: resolve => require(['@/views/trigger/add.vue'], resolve), name: '编辑预警设置', hidden: true , meta: {roles:['admin']}},
            { path: '/trigger/editL2', component: resolve => require(['@/views/trigger/addL2.vue'], resolve), name: '编辑预警设置', hidden: true , meta: {roles:['region_1', 'third_role_1']}},
            { path: '/trigger/contact', component: resolve => require(['@/views/trigger/contact/list.vue'], resolve), name: '报警联系人/组', meta: {roles:['admin']} },
            { path: '/trigger/contactL2', component: resolve => require(['@/views/trigger/contact/listL2.vue'], resolve), name: '报警联系人', meta: {roles:['region_1', 'third_role_1']} },
            // { path: '/trigger/alarmHistory', component: resolve => require(['@/views/trigger/alarmHistory.vue'], resolve), name: '报警记录' }
            { path: '/trigger/alarmHistory', component: resolve => require(['@/views/trigger/alarmHistoryL2.vue'], resolve), name: '报警记录', meta: {roles:['admin',"region_1", 'third_role_1']} },
            //{ path: '/trigger/alarmHistoryL2', component: resolve => require(['@/views/trigger/alarmHistoryL2.vue'], resolve), name: '报警记录',meta: {roles:['region_1']} }
        ],
        meta: {roles:['admin', 'region_1', 'third_role_1']}
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '触发器管理',
    //     iconCls: 'fa fa-bell',
    //     children: [
    //         { path: '/trigger/alarmHistoryL2', component: resolve => require(['@/views/trigger/alarmHistoryL2.vue'], resolve), name: '报警记录' }
    //     ],
    //     meta: {roles:['region_1']}
    // },
    {
        path: '/',
        component: Home,
        name: '用户中心',
        iconCls: 'fa fa-id-card-o',
        children: [
            { path: '/user/role', component: resolve => require(['@/views/user/role.vue'], resolve), name: '角色管理',meta: {roles:['admin']} },
            { path: '/user/user', component: resolve => require(['@/views/user/userL2.vue'], resolve), name: '子用户管理' ,meta: {roles:['admin', 'region_1']}},
            { path: '/user/info', component: resolve => require(['@/views/user/userinfo.vue'], resolve), name: '用户信息' ,meta: {roles:['admin']}},
            { path: '/user/password', component: resolve => require(['@/views/user/password.vue'], resolve), name: '用户密码' ,meta: {roles:['admin']}},
            { path: '/user/wxbind', component: resolve => require(['@/views/user/wxbind.vue'], resolve), name: '微信绑定管理' ,meta: {roles:['admin']}},
            { path: '/user/wxbindL2', component: resolve => require(['@/views/user/wxbindL2.vue'], resolve), name: '微信绑定管理' ,meta: {roles:['region_1', 'third_role_1']}},
            { path: '/user/infoL2', component: resolve => require(['@/views/user/userinfoL2.vue'], resolve), name: '用户信息',meta: {roles:['region_1', 'third_role_1']} },
            { path: '/user/passwordL2', component: resolve => require(['@/views/user/passwordL2.vue'], resolve), name: '用户密码',meta: {roles:['region_1', 'third_role_1']} },
        ],
        meta: {roles:['admin','region_1', 'third_role_1']}
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '用户中心',
    //     iconCls: 'fa fa-id-card-o',
    //     children: [
    //         { path: '/user/infoL2', component: resolve => require(['@/views/user/userinfoL2.vue'], resolve), name: '用户信息' },
    //         { path: '/user/passwordL2', component: resolve => require(['@/views/user/passwordL2.vue'], resolve), name: '用户密码' },
    //     ],
    //     meta: {roles:['region_1']}
    // },
    { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
    routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher // the relevant part
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js